import React from 'react';
import { useTranslation } from 'react-i18next';

import { addPublicURL } from '../../Functions/AddPublicURL';
import { getFromLocalStorage, saveToLocalStorage } from '../../Functions/LocalStorageUtils';
import { setControllerType } from '../../redux/reducers/appReducer';
import { useAppDispatch } from '../../redux/store';

import styles from './TechPopup.module.scss';

const TechPopup: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const tech = getFromLocalStorage('tech') || null;

    const handleClick = (type: string) => () => {
        dispatch(setControllerType(type));
        if(tech === null){
            saveToLocalStorage('tech', type);
            location.reload();
            return;
        }
        saveToLocalStorage('tech', type);
    }

    return (
        <div className={styles.TechPopup}>
            <div className={styles.TechPopup__wrapper}>
                <h2>{t('techPopup.heading')}</h2>
                <div className={styles.TechPopup__buttons}>
                    <div className={styles.TechPopup__button}>
                        <img onClick={handleClick('wireless')} src={addPublicURL('/assets/inels_wireless_logo.png')} alt="iNELS Wireless" />
                        <a href="https://hresk.inels.com/" target="_blank">hresk.inels.com</a>
                    </div>
                    <div className={styles.TechPopup__button}>
                        <img onClick={handleClick('bus')} src={addPublicURL('/assets/inels_bus_logo.png')} alt="iNELS Bus" />
                        <a href="https://grms.inels.com/" target="_blank">grms.inels.com</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TechPopup;